import { render, staticRenderFns } from "./LiveCam.vue?vue&type=template&id=24fd1895"
import script from "./LiveCam.vue?vue&type=script&lang=js"
export * from "./LiveCam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports